import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import DepartmentInventory from "./DepartmentInventory";
import DepartmentItemAnalysisReport from "./DepartmentItemAnalysisReport";
import StatusWiseReport from "./StatusWiseReport";
import EventWiseReport from "./EventWiseReport";
import DepartmentItemTransactionReport from "./DepartmentItemTransactionReport";
import OpeningStockReport from "./OpeningStockReport";
import DepartmentItem from "./departmentalItemsReport";
import { hasPermission } from "../utils/usePermissions";
import DepartmentIssueRequestReport from "./DepartmentIssueReport";
import DepartmentProformaX from "./DepartmentProformaX";
const DepartmentWiseReports = ({ accessOfDepartments, permissions }) => {
    const [selectedReport, setSelectedReport] = useState("");

    /* ================= RENDER SELECTED REPORT ================= */
    const renderReport = () => {
        switch (selectedReport) {
            case "overallInventory":
                return <DepartmentInventory accessOfDepartments={accessOfDepartments} />;

            case "itemAnalysis":
                return <DepartmentItemAnalysisReport accessOfDepartments={accessOfDepartments} />;

            case "statusWise":
                return <StatusWiseReport accessOfDepartments={accessOfDepartments} />;

            case "eventWise":
                return <EventWiseReport accessOfDepartments={accessOfDepartments} />;

            case "inventoryTransaction":
                return <DepartmentItemTransactionReport accessOfDepartments={accessOfDepartments} />;

            case "openingStock":
                return <OpeningStockReport accessOfDepartments={accessOfDepartments} />;

            case "itemList":
                return <DepartmentItem accessOfDepartments={accessOfDepartments} />;
            
            case "DepartmentIssueReport":
                return <DepartmentIssueRequestReport accessedDepartments={accessOfDepartments}/>;

            case "DepartmentProformaX":
                return <DepartmentProformaX accessOfDepartments={accessOfDepartments}/>;
            default:
                return (
                    <div className="text-muted mt-4">
                        Please select a report
                    </div>
                );
        }
    };
    const checkboxStyle = (checked) => ({
        width: "18px",
        height: "18px",
        border: "3px solid #198754",
        borderRadius: "2px",
        appearance: "none",
        cursor: "pointer",
        backgroundColor: checked ? "#198754" : "#fff",
    });

    const labelStyle = { cursor: "pointer" };


    return (
        <div className="container-fluid mt-5">
            {/* ================= HEADER ================= */}
            <div className="card">
                <div className="card-body">
                    {/* <h5 className="mb-3">Department Wise Reports</h5> */}

                    {/* ================= RADIO OPTIONS ================= */}
                    <div className="row">

                        {hasPermission(permissions, ['departmentInventory']) ?
                        <div className="col-md-4">
                            <div className="form-check d-flex align-items-center gap-2">
                                <input
                                    type="checkbox"
                                    id="overallInventory"
                                    checked={selectedReport === "overallInventory"}
                                    onChange={() => setSelectedReport("overallInventory")}
                                    style={checkboxStyle(selectedReport === "overallInventory")}
                                />
                                <label htmlFor="overallInventory" style={labelStyle}>
                                    Overall Department Inventory
                                </label>
                            </div>
                        </div>
                        :null }

                        {hasPermission(permissions, ['statusWiseReport']) ? 
                         <div className="col-md-4">
                            <div className="form-check d-flex align-items-center gap-2">
                                <input
                                    type="checkbox"
                                    id="statusWise"
                                    checked={selectedReport === "statusWise"}
                                    onChange={() => setSelectedReport("statusWise")}
                                    style={checkboxStyle(selectedReport === "statusWise")}
                                />
                                <label htmlFor="statusWise" style={labelStyle}>
                                    Status Wise Report
                                </label>
                            </div>
                        </div>
                        :null}

                        {hasPermission(permissions, ['eventWiseReports'])?
                        <div className="col-md-4">
                            <div className="form-check d-flex align-items-center gap-2">
                                <input
                                    type="checkbox"
                                    id="eventWise"
                                    checked={selectedReport === "eventWise"}
                                    onChange={() => setSelectedReport("eventWise")}
                                    style={checkboxStyle(selectedReport === "eventWise")}
                                />
                                <label htmlFor="eventWise" style={labelStyle}>
                                    Event Wise Report
                                </label>
                            </div>
                        </div>
                        :null}

                        {hasPermission(permissions, ['depttInventoryTransaction'])?
                        <div className="col-md-4">
                            <div className="form-check d-flex align-items-center gap-2">
                                <input
                                    type="checkbox"
                                    id="inventoryTransaction"
                                    checked={selectedReport === "inventoryTransaction"}
                                    onChange={() => setSelectedReport("inventoryTransaction")}
                                    style={checkboxStyle(selectedReport === "inventoryTransaction")}
                                />
                                <label htmlFor="inventoryTransaction" style={labelStyle}>
                                    Deptt Inventory Transaction
                                </label>
                            </div>
                        </div>:
                        null}

                        {hasPermission(permissions, ['openingStockReport'])?
                        <div className="col-md-4">
                            <div className="form-check d-flex align-items-center gap-2">
                                <input
                                    type="checkbox"
                                    id="openingStock"
                                    checked={selectedReport === "openingStock"}
                                    onChange={() => setSelectedReport("openingStock")}
                                    style={checkboxStyle(selectedReport === "openingStock")}
                                />
                                <label htmlFor="openingStock" style={labelStyle}>
                                    Department Opening Stock
                                </label>
                            </div>
                        </div>
                        :null}

                        {hasPermission(permissions, ['departmentItemList'])?
                        <div className="col-md-4">
                            <div className="form-check d-flex align-items-center gap-2">
                                <input
                                    type="checkbox"
                                    id="itemList"
                                    checked={selectedReport === "itemList"}
                                    onChange={() => setSelectedReport("itemList")}
                                    style={checkboxStyle(selectedReport === "itemList")}
                                />
                                <label htmlFor="itemList" style={labelStyle}>
                                    Department Item List
                                </label>
                            </div>
                        </div>:null}

                        {hasPermission(permissions, ['DepartmentIssueReport'])?
                        <div className="col-md-4">
                            <div className="form-check d-flex align-items-center gap-2">
                                <input
                                    type="checkbox"
                                    id="DepartmentIssueReport"
                                    checked={selectedReport === "DepartmentIssueReport"}
                                    onChange={() => setSelectedReport("DepartmentIssueReport")}
                                    style={checkboxStyle(selectedReport === "DepartmentIssueReport")}
                                />
                                <label htmlFor="DepartmentIssueReport" style={labelStyle}>
                                    Department Issue Report
                                </label>
                            </div>
                        </div>:null}

                        {hasPermission(permissions, ['DepartmentProformaX'])?
                        <div className="col-md-4">
                            <div className="form-check d-flex align-items-center gap-2">
                                <input
                                    type="checkbox"
                                    id="DepartmentProformaX"
                                    checked={selectedReport === "DepartmentProformaX"}
                                    onChange={() => setSelectedReport("DepartmentProformaX")}
                                    style={checkboxStyle(selectedReport === "DepartmentProformaX")}
                                />
                                <label htmlFor="DepartmentProformaX" style={labelStyle}>
                                    Department Proforma X
                                </label>
                            </div>
                        </div>:null}
                    </div>

                </div>
            </div>
            <div className="">{renderReport()}</div>
        </div>
    );
};

export default DepartmentWiseReports;
